import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DropdownMenuLabel } from '../../patched-dropdown/Dropdown.mjs';
import { dropdownLabel } from '../../shared/styles/label.vanilla.mjs';

const DropdownLabel = forwardRef(
  ({ className: classNameFromProps, ...props }, forwardedRef) => {
    const className = classNames(dropdownLabel, classNameFromProps);
    return /* @__PURE__ */ jsx(
      DropdownMenuLabel,
      {
        "data-scope": "dropdown",
        "data-part": "label",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);

export { DropdownLabel };
//# sourceMappingURL=Label.mjs.map
